import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { Filters } from '@widgets/dating/components';

export const Route = createFileRoute('/dating/filters')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page>
        <Filters />
      </Page>
    </>
  );
}
